<template>
  <!-- WorkType -->
  <div class="h-100">
    <div class="content-page p-3 pb-5 h-100">
      <b-row>
        <b-col
          cols="12"
          class="text-right"
          v-if="hasRight(Settings.Permission.Change) && hasRight('AlwWrite')"
        >
          <button
            class="btn btn-info"
            @click="initWorkType"
            v-b-modal.modal-workType
          >
            {{ `${this.t.t(dictEnum.LBL_Add)} ` }}
          </button>
        </b-col>
      </b-row>
      <b-row class="h-100">
        <b-col cols="12" class="h-100 pb-5">
          <div class="tab-content bg-white h-100">
            <div class="tab-pane active table-responsive color-table">
              <v-client-table
                :data="tableData"
                :columns="columns"
                :options="options"
              >
                <template slot="Action" slot-scope="props">
                  <div>
                    <font-awesome-icon
                      icon="edit"
                      style="cursor:pointer"
                      v-if="hasRight(Settings.Permission.Change)"
                      v-b-modal.modal-workType
                      @click="editWorkType(props.row)"
                    />

                    <font-awesome-icon
                      icon="trash"
                      style="cursor:pointer"
                      v-if="hasRight('AlwDel')"
                      @click="deleteWorkType(props.row)"
                    />
                  </div>
                </template>
              </v-client-table>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>

    <b-modal
      id="modal-workType"
      :title="mode == 'new' ? t.t(dictEnum.LBL_Add) : t.t(dictEnum.BTN_Update)"
      :ok-title="t.t(dictEnum.BTN_Submit)"
      :cancel-title="t.t(dictEnum.BTN_Cancel)"
      @ok="editOrAddWorkType"
    >
      <div class="p-3">
        <b-row class="my-1 no-gutters">
          <b-col sm="5">
            <b-input-group-prepend is-text>
              <span class="bg-white">{{ t.t(dictEnum.LBL_WorkType) }}</span>
            </b-input-group-prepend>
          </b-col>
          <b-col sm="7">
            <b-form-group class="font-weight-normal">
              <b-form-input
                v-model="workType.WorkType"
                maxlength="15"
                :readonly="mode === 'new' ? false : true"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="my-1 no-gutters">
          <b-col sm="5">
            <b-input-group-prepend is-text>
              <span class="bg-white">{{ t.t(dictEnum.LBL_EngDesc) }}</span>
            </b-input-group-prepend>
          </b-col>
          <b-col sm="7">
            <b-form-group class="font-weight-normal">
              <b-form-input
                v-model="workType.EDesc"
                maxlength="50"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="my-1 no-gutters">
          <b-col sm="5">
            <b-input-group-prepend is-text>
              <span class="bg-white">{{ t.t(dictEnum.LBL_ChiDesc) }}</span>
            </b-input-group-prepend>
          </b-col>
          <b-col sm="7">
            <b-form-group class="font-weight-normal">
              <b-form-input
                maxlength="50"
                v-model="workType.CDesc"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>

<script>
import MenuRightSerivce from "@/service/MenuRightService";
import WorkTypeService from "@/service/WorkTypeService";
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import SweetAlertService from "@/service/SweetAlertService";
import StoreGetter from "@/constants/StoreGetter";
import { WorkType } from "@/model/WorkType";
import Settings from "../../constants/Settings";

export default {
  components: {},
  computed: {
    t() {
      return t;
    }
  },
  data() {
    return {
      menuRights: { allRights: {}, rightsForThisMenu: {} },
      menuId: Settings.MenuID.MM_WorkType,
      Settings: Settings,
      columns: ["WorkType", "EDesc", "CDesc", "Action"],
      tableData: [],
      dictEnum: dictEnum,
      options: {
        filterable: false,
        perPageValues: [],
        sortable: [],
        skin: "table table-hover v-midle",
        headings: {
          WorkType: "Work Type",
          EDesc: "Eng Description",
          CDesc: "Chi Description",
          Action: "Action"
        },
        columnsClasses: {}
      },
      mode: "new",
      workType: new WorkType()
    };
  },
  methods: {
    hasRight(key) {
      if (Object.keys(this.menuRights.allRights).length === 0) {
        return false;
      } else {
        return MenuRightSerivce.hasRightInMenu(
          this.menuRights.allRights,
          this.menuId,
          key
        );
      }
    },
    assignRights() {
      this.menuRights.allRights = this.$store.getters[StoreGetter.sysMenu];
      this.menuRights.rightsForThisMenu = this.menuRights.allRights.find(
        x => x.MenuID == this.menuId
      );
    },
    initWorkType() {
      this.mode = "new";
      this.workType = new WorkType();
    },
    editWorkType(workType) {
      this.mode = "edit";
      this.workType = workType;
    },
    async deleteWorkType(grade) {
      const sweetAlertOptions = {
        title: this.t.t(dictEnum.WARN_Confirm),
        text: `${t.t(dictEnum.WARN_DeleteWorkType)}`,
        cancelButtonText: this.t.t(dictEnum.BTN_Cancel),
        confirmButtonText: this.t.t(dictEnum.BTN_Confirm)
      };
      const result = await SweetAlertService.question(sweetAlertOptions);
      if (result.value) {
        const obj = {
          WorkType: grade.WorkType,
          UserId: this.$store.getters[StoreGetter.user].UserID
        };

        const response = await WorkTypeService.deleteWorkType(obj);
        if (response.data.IsSuccess) {
          SweetAlertService.success("Success", response.data.Message);
          this.getDataTable();
        } else {
          SweetAlertService.warning("Warn", response.data.Message);
        }
      }
    },

    async editOrAddWorkType() {
      if (!this.workType.WorkType) {
        SweetAlertService.warning(
          "Warn",
          t.t(dictEnum.MENU_WorkType) + t.t(dictEnum.WARN_IsRequired)
        );
        return;
      }

      if (!this.workType.EDesc) {
        SweetAlertService.warning(
          "Warn",
          t.t(dictEnum.LBL_Description) + t.t(dictEnum.WARN_IsRequired)
        );
        return;
      }
      if (!this.workType.CDesc) {
        SweetAlertService.warning(
          "Warn",
          t.t(dictEnum.LBL_Description) + t.t(dictEnum.WARN_IsRequired)
        );
        return;
      }

      const obj = {
        model: this.workType
      };

      const response =
        this.mode === "new"
          ? await WorkTypeService.addWorkType(obj)
          : await WorkTypeService.updateWorkType(obj);

      if (response.data.IsSuccess) {
        this.workType = new WorkType();
        SweetAlertService.success("Success", response.data.Message);
        this.getDataTable();
      } else {
        this.workType = new WorkType();
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },

    async getDataTable() {
      const obj = {};

      const response = await WorkTypeService.getWorkTypes(obj);

      if (response.data.IsSuccess) {
        this.tableData = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    }
  },
  mounted() {
    this.assignRights();
    this.getDataTable();

    this.options = {
      filterable: false,
      perPageValues: [],
      /* texts: {
        limit: "Records : ",
        },*/
      sortable: [],
      skin: "table table-hover v-midle",
      headings: {
        WorkType: t.t(dictEnum.LBL_WorkType),
        EDesc: t.t(dictEnum.LBL_EngDesc),
        CDesc: t.t(dictEnum.LBL_ChiDesc),
        Action: t.t(dictEnum.BTN_Update)
      },
      texts: {
        noResults: t.t(dictEnum.LBL_NoData),
        count: ``
      },
      columnsClasses: {}
    };
  }
};
</script>
<style scoped>
.input-group-text {
  background: white;
  border: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/S050000-MM/S050400-WorkType.vue